import React, { ReactNode } from 'react';
import { cx } from '@linaria/core';
import { styled } from '@linaria/react';
import { ButtonLink } from '@daedalus/atlas/ButtonLink';
import { Grid } from '@daedalus/atlas/helpers/Grid';
import { Price } from '@daedalus/atlas/Price';
import { Text } from '@daedalus/atlas/Text';
import { Tooltip, TooltipPlacement } from '@daedalus/atlas/Tooltip';
import { defaultCurrencyCode } from '@daedalus/core/src/localization/business/currency';
import { CurrencyDisplayVariant } from '@daedalus/core/src/price/business/formatPrice';
import { NUMBER_OF_DECIMALS_FOR_PRICE } from '.';
import { PriceDetailsSkeleton } from './Skeleton';
interface PriceLineProps {
  label?: ReactNode;
  price: number;
  currencyCode?: string;
  showFeesDescriptions?: boolean;
  noMargin?: boolean;
  reducedMargin?: boolean;
  tooltipBody?: ReactNode;
  icon?: ReactNode;
  isPriceLoading?: boolean;
  onInfoClick?: () => void;
  currencyDisplayVariant?: CurrencyDisplayVariant;
}
const PriceLineWrapper = /*#__PURE__*/styled('div')({
  name: "PriceLineWrapper",
  class: "p6crw9x",
  propsAsIs: false
});
const _exp3 = /*#__PURE__*/() => Grid;
const FlexGrid = /*#__PURE__*/styled(_exp3())({
  name: "FlexGrid",
  class: "f15ffhk",
  propsAsIs: true
});
const _exp4 = /*#__PURE__*/() => Text;
export const StyledText = /*#__PURE__*/styled(_exp4())({
  name: "StyledText",
  class: "s1dlz8ql",
  propsAsIs: true
});
const _exp6 = /*#__PURE__*/() => Price;
const StyledPrice = /*#__PURE__*/styled(_exp6())({
  name: "StyledPrice",
  class: "s1htog6y",
  propsAsIs: true
});
const PriceLine = ({
  label,
  price,
  showFeesDescriptions,
  tooltipBody,
  icon,
  onInfoClick,
  currencyCode = defaultCurrencyCode,
  isPriceLoading = false,
  noMargin = false,
  reducedMargin = false,
  currencyDisplayVariant
}: PriceLineProps) => {
  return <PriceLineWrapper className={cx(!noMargin && 'withMargin', reducedMargin && 'withReducedMargin')}>
      <Grid container justify="space-between" alignItems="flex-start">
        <FlexGrid mobileSm="fit" wrap="nowrap" alignItems="center">
          {showFeesDescriptions ? <>
              {tooltipBody ? <Tooltip placement={TooltipPlacement.Top} content={tooltipBody}>
                  <StyledText variant="bodyM">{label}</StyledText>
                </Tooltip> : <ButtonLink target="_blank" onClick={onInfoClick} onKeyPress={onInfoClick} rel="noreferrer" size="md" isCompact variant="info" isDotted data-id="taxes-and-fees-button">
                  <Text variant="bodyM" colorPath="content.neutral.c950">
                    {label}
                  </Text>
                </ButtonLink>}
              {icon}
            </> : <Text variant="bodyM">{label}</Text>}
        </FlexGrid>

        <Grid mobileSm="fit">
          <Grid container direction="column" alignItems="flex-end">
            <Grid>
              {isPriceLoading ? <PriceDetailsSkeleton /> : <StyledPrice noStyle maximumFractionDigits={NUMBER_OF_DECIMALS_FOR_PRICE} minimumFractionDigits={NUMBER_OF_DECIMALS_FOR_PRICE} value={price} currency={currencyCode} currencyDisplayVariant={currencyDisplayVariant} />}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </PriceLineWrapper>;
};
export default PriceLine;

require("./PriceLine.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./PriceLine.tsx");